export default {
  setToken(state, payload) {
    state.token = payload;
  },

  setUser(state, payload) {
    state.user = payload;
  },

  setUsers(state, payload) {
    localStorage.setItem("users", JSON.stringify(payload));
    state.users = payload;
  },

  setAuth(state, payload) {
    state.auth = payload;
  },

  setCampings(state, payload) {
    localStorage.setItem("campings", JSON.stringify(payload));
    state.campings = payload;
  },

  setCamping(state, payload) {
    localStorage.setItem("camping", JSON.stringify(payload));
    state.camping = payload;
  },

  setScontoSoloSuUnita(state, payload) {
    localStorage.setItem("parameters", JSON.stringify(payload));
    state.parameters = payload;
  },

  auth(state, payload) {
    state.token = payload.token;
    state.user = JSON.parse(JSON.stringify(payload.user));
    state.auth = true;
    localStorage.setItem("token", payload.token);
    localStorage.setItem("user", payload.user);
  },
};
